import './AdSettingsMenu.scss';

import { IconAdd, IconCopy, IconDelete, IconSettings } from '@hulu-react-style-components/icons';
import { bem } from 'mission-control-common-components';
import React from 'react';

import BasicSelect from '../../../../../../../common/BasicSelect';

const [, element] = bem('ad-settings-menu');

type AdSettingsMenuProps = {
  onClone: () => void;
  onAddTag: () => void;
  onDelete: () => void;
};

const AdSettingsMenu = ({ onClone, onAddTag, onDelete }: AdSettingsMenuProps): React.JSX.Element => {
  const optionsComponent = (toggleOpen: () => void): React.ReactElement => (
    <div className={element('dropdown')} data-testid="ad-settings-dropdown">
      <button
        type="button"
        className={element('item')}
        onClick={() => {
          onClone();
          toggleOpen();
        }}
        data-testid="ad-settings-clone"
      >
        <IconCopy className={element('icon')} />
        <span>Clone</span>
      </button>
      <button
        type="button"
        className={element('item')}
        onClick={() => {
          onAddTag();
          toggleOpen();
        }}
        data-testid="ad-settings-add-tag"
      >
        <IconAdd className={element('icon')} />
        <span>Add Measurement</span>
      </button>
      <button
        type="button"
        className={element('item', 'delete')}
        onClick={() => {
          onDelete();
          toggleOpen();
        }}
        data-testid="ad-settings-delete"
      >
        <IconDelete className={element('icon')} />
        <span>Delete</span>
      </button>
    </div>
  );

  return (
    <BasicSelect
      buttonText=""
      leftIcon={<IconSettings />}
      hideDefaultRightIcon
      optionsComponent={optionsComponent}
      selectButtonClassName={element('trigger')}
      overlayClassName={element('tooltip')}
    />
  );
};

export default AdSettingsMenu;
